/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Health OS API
 * API documentation for Health OS
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

/**
 * Generate a new access token using a valid refresh token. Tokens are delivered exclusively via HttpOnly cookies.
 * @summary Refresh access token
 */

export const RefreshBody = zod
  .object({
    refreshToken: zod.string().min(1).describe('JWT refresh token'),
  })
  .describe('Refresh token request for obtaining new access token');

export const RefreshResponse = zod
  .object({
    expiresIn: zod.number().nullish().describe('Access token expiration time in seconds'),
  })
  .describe('Token refresh response (tokens delivered via HttpOnly cookies)');

/**
 * Revoke all refresh tokens for the authenticated user
 * @summary Logout user
 */
export const LogoutResponse = zod.string();

/**
 * Revoke all refresh tokens for the authenticated user
 * @summary Logout from all devices
 */
export const LogoutAllResponse = zod.string();

/**
 * Authenticate user credentials. Tokens are delivered exclusively via HttpOnly cookies.
 * @summary User login
 */

export const loginBodyPasswordMin = 8;
export const loginBodyPasswordMax = 2147483647;

export const LoginBody = zod
  .object({
    email: zod.email().min(1).describe("User's email address"),
    password: zod
      .string()
      .min(loginBodyPasswordMin)
      .max(loginBodyPasswordMax)
      .describe("User's password"),
  })
  .describe('Login request containing user credentials');

export const LoginResponse = zod
  .object({
    expiresIn: zod.number().nullish().describe('Access token expiration time in seconds'),
    user: zod
      .object({
        email: zod.string().describe("User's email address"),
        firstName: zod.string().nullish(),
        lastName: zod.string().nullish(),
        roles: zod.array(zod.enum(['ADMIN', 'USER'])).nullish(),
        preferredLanguage: zod.enum(['en', 'de']).nullish(),
        id: zod.uuid().describe('User ID'),
        fullName: zod.string().nullish(),
      })
      .nullish()
      .describe('User information'),
  })
  .describe('Authentication response with user info (tokens delivered via HttpOnly cookies)');

/**
 * Consume a one-time login link token and issue JWT authentication cookies.
 * @summary Validate login link token
 */

export const ValidateLoginLinkBody = zod
  .object({
    token: zod.string().min(1).describe('The raw login link token from the email link'),
  })
  .describe('Request body for consuming a login link token');

export const ValidateLoginLinkResponse = zod
  .object({
    expiresIn: zod.number().nullish().describe('Access token expiration time in seconds'),
    user: zod
      .object({
        email: zod.string().describe("User's email address"),
        firstName: zod.string().nullish(),
        lastName: zod.string().nullish(),
        roles: zod.array(zod.enum(['ADMIN', 'USER'])).nullish(),
        preferredLanguage: zod.enum(['en', 'de']).nullish(),
        id: zod.uuid().describe('User ID'),
        fullName: zod.string().nullish(),
      })
      .nullish()
      .describe('User information'),
  })
  .describe('Authentication response with user info (tokens delivered via HttpOnly cookies)');

/**
 * Send a one-time login link to the provided email address. Returns 200 regardless of whether the email exists, to prevent user enumeration. May return 429 if the per-email request rate is exceeded.
 * @summary Request login link
 */

export const RequestLoginLinkBody = zod
  .object({
    email: zod.email().min(1).describe("User's email address"),
  })
  .describe('Request body for initiating a login link');

export const RequestLoginLinkResponse = zod.unknown();

/**
 * Return the authenticated user's profile. Uses the access token cookie for authentication.
 * @summary Get current user
 */
export const MeResponse = zod.object({
  email: zod.string().describe("User's email address"),
  firstName: zod.string().nullish(),
  lastName: zod.string().nullish(),
  roles: zod.array(zod.enum(['ADMIN', 'USER'])).nullish(),
  preferredLanguage: zod.enum(['en', 'de']).nullish(),
  id: zod.uuid().describe('User ID'),
  fullName: zod.string().nullish(),
});

/**
 * Check if the authentication service is running properly
 * @summary Authentication service health check
 */
export const HealthResponse = zod.string();

// === Auto-generated inferred types — DO NOT EDIT BELOW ===

export type RefreshBody = zod.infer<typeof RefreshBody>;
export type RefreshResponse = zod.infer<typeof RefreshResponse>;
export type LogoutResponse = zod.infer<typeof LogoutResponse>;
export type LogoutAllResponse = zod.infer<typeof LogoutAllResponse>;
export type LoginBody = zod.infer<typeof LoginBody>;
export type LoginResponse = zod.infer<typeof LoginResponse>;
export type ValidateLoginLinkBody = zod.infer<typeof ValidateLoginLinkBody>;
export type ValidateLoginLinkResponse = zod.infer<typeof ValidateLoginLinkResponse>;
export type RequestLoginLinkBody = zod.infer<typeof RequestLoginLinkBody>;
export type RequestLoginLinkResponse = zod.infer<typeof RequestLoginLinkResponse>;
export type MeResponse = zod.infer<typeof MeResponse>;
export type HealthResponse = zod.infer<typeof HealthResponse>;

// === End of auto-generated types ===
